module.exports = __webpack_public_path__ + "img/logo.942b8054.png";